import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/Navbar.module.css";
// import pwcLogo from "../../assets/newLogo.svg"
import { ReactComponent as PwcLogoSvg } from "assets/images/pwc-logo.svg";
import { Button, Link, useTheme, Dialog, DialogTitle, useMediaQuery, DialogActions } from "@mui/material";

const Headernp = ({ menus }) => {

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/projects/project-creation/project-list");
  };

  return (
    <>

      <div className={styles.navbar}>
        <div className={styles.left}>
          <div className={styles.logo} style={{ display: 'flex', marginTop: '4px' }}>
            <PwcLogoSvg />
          </div>
          {/* <div className={styles.active}>
            <Link href="" underline="none" style={{ fontSize: '16px', color: '#696969' }}>
              {"Create a Project"}
            </Link>
          </div> */}
        </div>
        <div className={styles.right}>
          <button className={styles.cancel}
            style={{
              border: `1px solid ${theme?.customSettings?.themeColor}`,
              color: theme?.customSettings?.themeColor,
            }}
            onClick={handleOpen}>
            Cancel
          </button>

        </div>
      </div>
      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return; // Prevent outside click
          handleClose(); // Allow manual close (like button click)
        }}
        disableEscapeKeyDown
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Do you want to discard unsaved changes?"}
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{
              border: `1px solid ${theme?.customSettings?.themeColor}`,
              color: theme?.customSettings?.themeColor,
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "24px",
              width: 100,
              textTransform: 'none',
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            sx={{
              background: theme?.customSettings?.themeColor,
              border: `1px solid ${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "24px",
              marginLeft: "10px",
              width: 100,
              textTransform: 'none',
            }}
            onClick={() => goHome()}
          >
            Discard
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Headernp;